// Work.js
import React from 'react';
// Make sure to import your CSS if Work.js is a separate file and App.css doesn't globally apply well enough
// import './Work.css'; // or make sure styles are in App.css

// Data for the projects
const projectsData = [
  {
    id: 1,
    title: "Inside Paul Hughes’s fight camp: Florida Training and NYC Media", // From user, matches PDF source [5]
    job: "location sound mixer", // From user, matches PDF source [5]
    link: "https://www.youtube.com/watch?v=Li7bZrZqurA", // Placeholder, replace with actual video/project link
    thumbnailPlaceholder: "Video Thumbnail 1", // For alt text or display
    bgColor: "#64B3D4", // Light blue
    layoutType: "imageLeft"
  },
  {
    id: 2,
    title: "What’s in the Toaster? (NSFW)", // From user, matches PDF source [5]
    job: "location sound mixer/boom op", // From user, matches PDF source [5]
    link: "https://www.youtube.com/watch?v=4UM75DB03Us", // Placeholder
    thumbnailPlaceholder: "Video Thumbnail 2",
    bgColor: "#164B72", // Dark blue
    layoutType: "imageRight"
  },
  {
    id: 3,
    title: "Beats, Bars & Beyond: Documentary Trailer", // From user, matches PDF source [6]
    job: "location sound mixer", // From user, matches PDF source [6]
    link: "https://www.youtube.com/watch?v=4dDLZVEoqBQ", // Placeholder
    thumbnailPlaceholder: "Video Thumbnail 3",
    bgColor: "#64B3D4", // Light blue
    layoutType: "imageLeft"
  },
  {
    id: 4,
    title: "Unknown Caller", // From user, matches PDF source [6]
    job: "Location Sound Mixer", // From user, matches PDF source [6]
    link: "https://vimeo.com/user208600065", // Vimeo User Profile
    thumbnailPlaceholder: "Video Thumbnail 4",
    bgColor: "#164B72", // Dark blue
    layoutType: "imageRight"
  },
  {
    id: 5,
    title: "The Final Meow", // From user
    job: "location sound mixer", // From user
    link: "https://www.imdb.com/title/tt35461230/", // IMDB page
    thumbnailPlaceholder: "Project Thumbnail 5",
    bgColor: "#64B3D4", // Light blue
    layoutType: "imageLeft"
  }
];


function Work({ language, content }) { // Assuming 'content' prop has workText
  return (
    <section id="work" className="work-section">
      {/* Top intro part of the work section (photo + text) */}
      <div className="work-intro">
        <div className="work-intro-photo">
          {/* Background image set in CSS */}
        </div>
        <div className="work-intro-text">
          <p>{content.workText}</p>
        </div>
      </div>

      {/* Projects Title Bar */}
      <div className="work-projects-title-bar">
        <h2>PROJECTS</h2> {/* Changed to H2 for semantics, styled to be big and bold */}
      </div>

      {/* Projects List */}
      <div className="work-projects-list">
        {projectsData.map((project) => (
          <div
            key={project.id}
            className={`project-item ${project.layoutType === 'imageRight' ? 'image-right' : 'image-left'}`}
            style={{ backgroundColor: project.bgColor }}
          >
            <a
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              className="project-thumbnail-link"
              aria-label={`Link to project: ${project.title}`}
            >
              <div className="project-thumbnail-placeholder">
                {/* You can put an icon or text here. For a real site, use an <img> tag */}
                <span>▶ View Project</span>
                 {/* <img src={project.actualThumbnailUrl} alt={project.title} /> */}
              </div>
            </a>
            <div className="project-text-container">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-job">{project.job}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Work;